import React from 'react';

import { FAB, Container, Item, LoadMoreButton } from 'components';

import ModeEditIcon from 'material-ui-icons/ModeEdit';

import { NavLink } from 'react-router-dom';

import ToolCard from './ToolCard';

const propTypes = {};

const defaultProps = {};

const ToolList = ({ data, onLoadMore, hasMore, ...rest }) => {
  return (
    <Container>
      <FAB component={NavLink} to="/tool/add">
        <ModeEditIcon />
      </FAB>
      <Item sm={8} md={6} lg={4}>
        {data &&
          data.allTools &&
          data.allTools.map(({ id, image, ...restToolData }) =>
            <ToolCard
              {...restToolData}
              key={id}
              imageUrl={image && image.url}
              onCardClick={() => {}}
            />
          )}

        <LoadMoreButton
          hasMore={hasMore}
          loading={data.loading}
          onClick={onLoadMore}
        />
      </Item>
    </Container>
  );
};

ToolList.propTypes = propTypes;
ToolList.defaultProps = defaultProps;

export default ToolList;



// WEBPACK FOOTER //
// ./src/App/Tool/components/ToolList.js